import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IYandexDropoffStation,
  IYandexDropoffStationsRequest
} from 'models/yandexDelivery'

export const yandexDeliveryApi = {
  getDropoffStations(
    data: IYandexDropoffStationsRequest
  ): Promise<AxiosResponse<IYandexDropoffStation[]>> {
    return privateApi.post<IYandexDropoffStation[]>(
      'yandex/other-day/pickup-points',
      data
    )
  }
}
